import { Component, OnInit, inject } from '@angular/core';
import { HeadService } from '../../services/head.service';
import { TitleService } from '../../services/title.service';
import { environment } from '../../../environments/environment';
import { ImgSrcSetDirective } from '../../directives/img-src-set.directive';
import { YoutubePlayerComponent } from '../youtube-player/youtube-player.component';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [ImgSrcSetDirective, YoutubePlayerComponent]
})
export class HomeComponent implements OnInit {
  private headService = inject(HeadService);
  private titleService = inject(TitleService);


  ngOnInit(): void {
    const title = 'Irish Celtic Jewellery';
    this.titleService.set(title, false);
    this.headService.createCanonicalLink(environment.root);
    this.headService.setMetaDescription(`Welcome to Irish Celtic Jewellery. 
    Handcrafted celtic wedding rings, diamond engagement rings and stylish modern designs.`);
    this.headService.setOrgStructuredData();
  }
}
